import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Mail, Calendar, Phone, Clock, Users, Camera } from 'lucide-react';

const MediaContact = () => {
  return (
    <section className="space-y-12">
      <div className="text-center">
        <h2 className="text-4xl font-montserrat font-bold text-[#894D1D] mb-4">
          Media Contact
        </h2>
        <div className="w-20 h-1 bg-gradient-to-r from-[#894D1D] to-[#698235] mx-auto rounded-full"></div>
      </div>
      
      <div className="grid lg:grid-cols-2 gap-8">
        {/* Contact Info Card */}
        <Card className="bg-gradient-to-br from-[#894D1D] to-[#698235] text-white shadow-xl">
          <CardHeader className="text-center pb-6">
            <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
              <Mail className="h-8 w-8 text-white" />
            </div>
            <CardTitle className="text-2xl font-montserrat">
              Primary Media Contact
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="text-center">
              <div className="text-xl font-semibold font-montserrat mb-2">
                Dan Rimada
              </div>
              <div className="text-white/80 font-montserrat">
                Co-founder & Media Relations
              </div>
            </div>
            
            <div className="space-y-4">
              <div className="flex items-center justify-center gap-3 text-white/90">
                <Mail className="h-5 w-5" />
                <span className="font-montserrat">catsabouttowntours@gmail.com</span>
              </div>
              
              <div className="flex items-center justify-center gap-3 text-white/80">
                <Clock className="h-5 w-5" />
                <span className="font-montserrat text-sm">Responds within 24 hours</span>
              </div>
            </div>

            <div className="pt-4">
              <a 
                href="mailto:catsabouttowntours@gmail.com?subject=Media Inquiry - Cats About Town Tours"
                className="block w-full"
              >
                <Button 
                  variant="outline" 
                  className="w-full bg-white/10 border-white/30 text-white hover:bg-white hover:text-[#894D1D] font-montserrat transition-all duration-300"
                >
                  <Mail className="mr-2 h-4 w-4" />
                  Send Media Inquiry
                </Button>
              </a>
            </div>
          </CardContent>
        </Card>

        {/* Opportunities Card */}
        <Card className="bg-white border-[#894D1D]/10 shadow-xl">
          <CardHeader className="text-center pb-6">
            <div className="w-16 h-16 bg-gradient-to-r from-[#894D1D] to-[#698235] rounded-full flex items-center justify-center mx-auto mb-4">
              <Users className="h-8 w-8 text-white" />
            </div>
            <CardTitle className="text-2xl font-montserrat text-[#894D1D]">
              Coverage Opportunities
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-6">
              {[
                {
                  icon: Calendar,
                  title: "Tour Attendance",
                  desc: "Join a tour for first-hand coverage and photo opportunities"
                },
                {
                  icon: Users,
                  title: "Expert Interviews",
                  desc: "Commentary from Peggy Gavan on NYC feline folklore and history"
                },
                {
                  icon: Camera,
                  title: "Behind-the-Scenes",
                  desc: "Access to tour research and preparation process"
                }
              ].map((opportunity, index) => (
                <div key={index} className="flex items-start gap-4 p-4 bg-[#F7F0DE]/50 rounded-xl">
                  <div className="w-10 h-10 bg-gradient-to-r from-[#894D1D] to-[#698235] rounded-full flex items-center justify-center flex-shrink-0">
                    <opportunity.icon className="h-5 w-5 text-white" />
                  </div>
                  <div>
                    <div className="font-semibold text-[#894D1D] font-montserrat mb-1">
                      {opportunity.title}
                    </div>
                    <div className="text-sm text-[#894D1D]/70 font-montserrat">
                      {opportunity.desc}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default MediaContact;
